import Vue from 'vue';
import VueGtag from 'vue-gtag';
import router from '../router';

const isProduction = process.env.NODE_ENV === 'production' && process.env.VUE_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID;
const isStaging = process.env.NODE_ENV === 'staging' && process.env.VUE_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID;

Vue.use(
  VueGtag,
  {
    config: {
      id: `${process.env.VUE_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID}`,
      params: {
        send_page_view: false,
      },
    },
    enabled: isProduction || isStaging,
  },
  router
);
